import _regeneratorRuntime from "@babel/runtime/regenerator";
var _jsxFileName = "/home/bradley/Code/teamgantt/react-auto-translate/src/translator.tsx";
import React, { createContext } from 'react';
var defaultHandler = function defaultHandler() {};
export var TranslateContext = createContext(defaultHandler);
export var LanguageContext = createContext('en');
export default function Translator(_ref) {
  var to = _ref.to,
    from = _ref.from,
    cacheProvider = _ref.cacheProvider,
    children = _ref.children,
    googleApiKey = _ref.googleApiKey;
  var getCachedTranslation = function getCachedTranslation(value) {
    if (!cacheProvider) {
      return undefined;
    }
    return cacheProvider.get(to, value);
  };
  var setCachedTranslation = function setCachedTranslation(value, translation) {
    if (!cacheProvider) {
      return;
    }
    cacheProvider.set(to, value, translation);
  };
  var getGoogleTranslation = function getGoogleTranslation(value) {
    var response, jsonResponse;
    return _regeneratorRuntime.async(function getGoogleTranslation$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _regeneratorRuntime.awrap(fetch("https://translation.googleapis.com/language/translate/v2?source=" + from + "&target=" + to + "&key=" + googleApiKey + "&q=" + value + "&format=text"));
          case 3:
            response = _context.sent;
            _context.next = 6;
            return _regeneratorRuntime.awrap(response.json());
          case 6:
            jsonResponse = _context.sent;
            return _context.abrupt("return", jsonResponse.data.translations[0].translatedText);
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", undefined);
          case 13:
          case "end":
            return _context.stop();
        }
      }
    }, null, null, [[0, 10]]);
  };
  var handleTranslationAsync = function handleTranslationAsync(value, setTranslation) {
    var cachedTranslation, translatedText;
    return _regeneratorRuntime.async(function handleTranslationAsync$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(to === from)) {
              _context2.next = 3;
              break;
            }
            setTranslation(value);
            return _context2.abrupt("return");
          case 3:
            cachedTranslation = getCachedTranslation(value);
            if (!cachedTranslation) {
              _context2.next = 7;
              break;
            }
            setTranslation(cachedTranslation);
            return _context2.abrupt("return");
          case 7:
            _context2.next = 9;
            return _regeneratorRuntime.awrap(getGoogleTranslation(value));
          case 9:
            translatedText = _context2.sent;
            if (!translatedText) {
              _context2.next = 14;
              break;
            }
            setCachedTranslation(value, translatedText);
            setTranslation(translatedText);
            return _context2.abrupt("return");
          case 14:
            setTranslation(value);
          case 15:
          case "end":
            return _context2.stop();
        }
      }
    });
  };
  return React.createElement(TranslateContext.Provider, {
    value: handleTranslationAsync,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 96
    }
  }, React.createElement(LanguageContext.Provider, {
    value: to,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 97
    }
  }, children));
}